import * as localReferentielKeys from "./localReferentielKeys";

const localReferentielApis = {
  [localReferentielKeys.ROLES_OPERATEUR_LOCAL_REFERENTIEL_KEY]:
    "/roles-operateur/all-active-roles",
  [localReferentielKeys.CODES_PACKAGES_LOCAL_REFERENTIEL_KEY]:
    "/packages/codes",
};

export default localReferentielApis;
